<template>
  <div>
    <b-overlay :show="showOverlay" class="b-overlay-app" rounded="sm">
      <h2 class="mb-5">Connexion</h2>

      <form @submit="handleSubmit">
        <div class="form-group">
          <label for="username">Nom d'utilisateur</label>
          <input
            id="username"
            v-model="credentials.username"
            :class="{ 'form-control': true, 'is-invalid': error != '' }"
            name="username"
            placeholder="Nom d'utilisateur"
            type="text"
          />
          <p v-show="error != ''" class="invalid-feedback">{{ error }}</p>
        </div>
        <div class="form-group">
          <label for="password">Mot de passe</label>
          <input
            id="password"
            v-model="credentials.password"
            class="form-control"
            name="password"
            placeholder="Mot de passe"
            type="password"
          />
        </div>

        <div class="form-group">
          <button id="bouton-login" class="btn btn-success" type="submit">
            Je me connecte
          </button>
        </div>
      </form>
    </b-overlay>
  </div>
</template>

<script>
import AuthAPI from "../services/authAPI";
import toast from "../js/toast";
import { mapActions } from 'vuex';

export default {
  name: "LoginPage",
  data() {
    return {
      credentials: {
        username: "",
        password: "",
      },
      error: "",
      showOverlay: false,
    };
  },
  methods: {
    ...mapActions('sollicitations', ['clearSollicitations']),
    async handleSubmit(event) {
      event.preventDefault();

      // Desactivation du bouton login
      let boutonLogin = document.getElementById("bouton-login");
      boutonLogin.disabled = true;
      this.showOverlay = true;

      let temp;
      if (!this.credentials.username.includes("@"))
        this.credentials.username = this.credentials.username.concat("@amsom-habitat.fr");
      temp = await this.connect();
      switch (temp) {
        case 401: this.error = "Aucun compte ne possède ce nom d'utilisateur ou vos identifiants sont incorrectes"; break;
        case 403: this.error = "Vous n'avez pas le droit d'acceder à l'application"; break;
        default : this.error = "Une erreur s'est produite, merci de ré-essayer ultérieurement";
      }
      this.showOverlay = false;
      boutonLogin.disabled = false;
      this.showOverlay = false;
      boutonLogin.disabled = false;

    },
    async connect() {
      try {
        toast.showToast("info", "Demande de connexion patienter...", 2000);
        await AuthAPI.authenticate(this.credentials).then(() => {
          toast.showToast("info", "Vous êtes connecté", 2000);
          this.clearSollicitations();
          const self = this
          const goToHome = function () {self.$router.push({name: 'home'})}
          this.$userManager.redirectionAfterLogin(goToHome)
        });
        return null;
      } catch (e) {
        return e?.response?.status ?? e;
      }
    }
  }
};
</script>

<style scoped>
form {
  margin: 0 20px;
}
</style>
